import { createSlice } from "@reduxjs/toolkit";
import { BookStoreType } from "types/BookType";
import { ListSerializersListBook, ReadingJournalSerializersJournal, TagSerializersBasicTag, UserBookSerializersUserBook, UserBookSerializersUserBookDate } from "types/serializers";

export type BooksStateType = {
  books: Record<number, BookStoreType>;
};

export const booksState: BooksStateType = {
  books: {}
};

const booksSlice = createSlice({
  name: "BooksSlice",
  initialState: booksState,
  reducers: {
    setBook(state, { payload: { book } }: { payload: { book: BookStoreType } }) {
      state.books[book.book.id] = book;
    },
    setUserBook(
      state,
      { payload: { userBook } }: { payload: { userBook: UserBookSerializersUserBook } }
    ) {
      state.books[userBook.bookId] = state.books[userBook.bookId] || {} as unknown as BookStoreType;
      state.books[userBook.bookId].userBook = userBook;
    },
    removeUserBook(state, { payload: { bookId } }: { payload: { bookId: number } }) {
      if(state.books[String(bookId)]?.userBook) {
        delete state.books[String(bookId)].userBook;
      }
    },
    setUserBookRead(
      state,
      { payload: { bookId, userBookRead } }: { payload: { bookId: number; userBookRead: UserBookSerializersUserBookDate } }
    ) {
      // Check if this is an update or an addition
      let found = false;

      if (!state.books[bookId]?.userBook) {
        return;
      }

      state.books[bookId].userBook.datesRead.forEach((dateRead, index) => {
        if (dateRead.id === userBookRead.id) {
          state.books[bookId].userBook.datesRead[index] = userBookRead;
          found = true;
        }
      });

      if(!found) {
        state.books[bookId].userBook.datesRead.push(userBookRead);
      }
    },
    removeUserBookRead(state, { payload: { bookId, userBookReadId } }: { payload: { bookId: number; userBookReadId: number } }) {
      state.books[bookId].userBook.datesRead = state.books[bookId].userBook.datesRead.filter((ubr) => ubr.id !== userBookReadId);
    },
    setListBook(
      state,
      { payload: { bookId, listBook } }: { payload: { bookId: number; listBook: ListSerializersListBook } }
    ) {
      // Check if this is an update or an addition
      let found = false;
      state.books[bookId].listBooks ??= []; 
      state.books[bookId].listBooks.forEach((lb, index) => {
        if (lb.id === listBook.id) {
          state.books[bookId].listBooks[index] = listBook;
          found = true;
        }
      });

      if(!found) {
        state.books[bookId].listBooks.push(listBook);
      }
    },
    setListBooks(
      state,
      { payload: { bookId, listBooks } }: { payload: { bookId: number; listBooks: ListSerializersListBook[] } }
    ) {
      state.books[bookId].listBooks = listBooks;
    },
    removeListBook(state, { payload: { bookId, listBookId } }: { payload: { bookId: number; listBookId: number } }) {
      state.books[bookId].listBooks = state.books[bookId].listBooks.filter((listBook) => listBook.id !== listBookId);
    },
    setTags(
      state,
      { payload: { bookId, tags } }: { payload: { bookId: number; tags: TagSerializersBasicTag[] } }
    ) {
      state.books[bookId].tags = tags;
    },
    removeJournal(state, { payload: { bookId, journalId } }: { payload: { bookId: number; journalId: number } }) {
      state.books[bookId].journals = state.books[bookId].journals.filter((journal) => journal.id !== journalId);
    },
    setJournals(
      state,
      { payload: { bookId, journals } }: { payload: { bookId: number; journals: ReadingJournalSerializersJournal[] } }
    ) {
      state.books[bookId].journals = journals;
    },
  },
});

export const bookActions = booksSlice.actions;

export default booksSlice.reducer;

export const { setBook, setUserBook, removeUserBook, setUserBookRead, removeUserBookRead, setListBook, removeListBook, setListBooks, setTags, removeJournal, setJournals } = booksSlice.actions;
